import React, { JSX, useMemo } from "react";

export interface DisplayTextWrappedProps {
  text: string;
  maxChars: number;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
}

export const DisplayTextWrapped: React.FC<DisplayTextWrappedProps> = ({
  text,
  maxChars,
  as: Tag = "span",
  className,
}) => {
  const lines = useMemo(() => {
    if (!text) return [] as string[];
    const words = text.split(/\s+/);
    const out: string[] = [];
    let current = "";
    for (const word of words) {
      if (!current) {
        current = word;
      } else if (current.length + 1 + word.length <= maxChars) {
        current += ` ${word}`;
      } else {
        out.push(current);
        current = word;
      }
    }
    if (current) out.push(current);
    return out;
  }, [text, maxChars]);

  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i}>
          {line}
          {i < lines.length - 1 && <br />}
        </span>
      ))}
    </Tag>
  );
};
